import React from "react";
import { Box, Text } from "braid-design-system";
import { useAuth } from "../contexts/AuthProvider";
import { useTranslation } from 'react-i18next';

const SiteFooter: React.FC = () => {
    const { user } = useAuth();
    const { t } = useTranslation();
    const year = new Date().getFullYear();
    const instituteName = user?.institute?.name_ln1 || '';

    const footerText = instituteName
        ? t('site.footer.text_with_institute', { year, institute: instituteName, defaultValue: `© ${year} Rajida POS • All rights reserved to ${instituteName}` })
        : t('site.footer.text', { year, defaultValue: `© ${year} Rajida POS • All rights reserved` });

    return (
        <Box paddingY="medium">
            <Text align="center" size="small" tone="secondary">
                {footerText}
            </Text>
        </Box>
    );
};

export default SiteFooter;